module.exports = __webpack_public_path__ + "static/img/2.4d3be02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/qiye/202000408/2.png
// module id = jRfu
// module chunks = 1